import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { SettingModel } from '../../models/resources/setting.model';

@Injectable({
  providedIn: 'root',
})
export class SettingService extends AResourceService<SettingModel> {

  constructor() {
    super('/configuration-profiles', true, [
      'location',
    ]);
  }
}
